export default "__VITE_ASSET__CgirI$jB__"